import React from 'react';
import { Logo } from '../Logo';
import { Button } from '../ui/Button';
import { InitialAvatar } from '../InitialAvatar';
import { WORDMARK } from '../../data/registration';
import { CURRENT_MEMBER } from '../../data/community';
const GUEST_LINKS = [{
  label: 'What’s in there',
  href: '#taste'
}, {
  label: 'Your privacy',
  href: '#privacy'
}];
const MEMBER_LINKS = [{
  label: 'Explore',
  href: '#explore'
}, {
  label: 'Archive',
  href: '#archive'
}, {
  label: 'Voices',
  href: '#voices'
}];
interface SiteHeaderProps {
  mode: 'guest' | 'member';
  onStart: () => void;
  startLabel: string;
  onSignIn: () => void;
  onSignOut: () => void;
}
export function SiteHeader({
  mode,
  onStart,
  startLabel,
  onSignIn,
  onSignOut
}: SiteHeaderProps) {
  const isMember = mode === 'member';
  const links = isMember ? MEMBER_LINKS : GUEST_LINKS;
  return <header className="sticky top-0 z-30 w-full border-b border-rule bg-card" data-id="element-259" data-mp="pwni6u202xh8">
      <div className="mx-auto flex min-h-[3.5rem] w-full max-w-5xl items-center justify-between gap-4 px-4 py-2 sm:px-6" data-id="element-260" data-mp="uycs26dhl53q">
        <a href="#top" className="flex flex-col rounded-control py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-261" data-mp="1s5bso61ji8u">
          <span className="text-heading font-semibold tracking-tight text-ink" data-id="element-262" data-mp="3o39gjxk42gla">
            We Are Stepping Stone
          </span>
          <span className="text-eyebrow-caption font-medium uppercase tracking-wide text-ink-muted" data-id="element-263" data-mp="kl9528fcjt2x">
            Run by alumni volunteers
          </span>
        </a>

        <nav aria-label="Portal" className="hidden items-center gap-6 lg:flex" data-id="element-264" data-mp="fnz9eb1d6l6n">
          {links.map(link => <a key={link.label} href={link.href} className="inline-flex min-h-tap items-center rounded-control text-small font-medium text-ink-muted hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-265" data-mp="6tkui9kqxco2">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-266" data-mp="2xrfsprwnkfby">
          {!isMember ? <span className="hidden items-center md:flex" data-id="element-267" data-mp="2xtigs6e8vye1">
              <span className="sr-only" data-id="element-268" data-mp="2j1i2z7j2rhkn">{WORDMARK}</span>
              {/* Guarded: the design-system bundle has shipped markers whose
                  exports didn't resolve at runtime. */}
              {Logo ? <Logo size="sm" aria-hidden="true" data-id="element-269" data-mp="2a0tjvyetqr0w" /> : null}
            </span> : null}

          <span aria-hidden="true" className="hidden h-6 w-px bg-rule md:block" data-id="element-270" data-mp="2f1zfc3zvcse4" />

          {isMember ? <>
              <span className="flex items-center gap-2" data-id="element-271" data-mp="205i5xib8pnu7">
                <InitialAvatar name={CURRENT_MEMBER.fullName} size={32} data-id="element-272" data-mp="2528nka2p0rhq" />
                <span className="hidden text-small font-medium text-ink sm:inline" data-id="element-273" data-mp="3uhos1c5o9p1a">
                  {CURRENT_MEMBER.publicName}
                </span>
              </span>
              <Button variant="secondary" onClick={onSignOut} data-id="element-274" data-mp="3alzaga6raoy">
                Sign out
              </Button>
            </> : <>
              <Button variant="secondary" onClick={onSignIn} data-id="element-275" data-mp="1iv4jiuwmcecy">
                Sign in
              </Button>
              <Button onClick={onStart} data-id="element-276" data-mp="1xkao6ye86ws8">{startLabel}</Button>
            </>}
        </div>
      </div>
    </header>;
}